import { BASE_URL, HTTP_URL } from '../constants';
import Timer from './Timer';

export const getImage = (imgName: string): string => {
	return 'https://s3.ap-south-1.amazonaws.com/govy.swiss/' + imgName;
};

export const api = (
	url: string,
	method: 'GET' | 'PUT' | 'POST' = 'GET',
	body?: any,
	infoObject?: { needStatusCode?: boolean },
	contentType: string = 'json'
): Promise<any> => {
	return fetch(HTTP_URL + BASE_URL + '/' + url, {
		//uat
		// return fetch('https://' + BASE_URL + '/' + url, {
		method,
		body: body
			? contentType && contentType === 'file'
				? body
				: JSON.stringify(body)
			: undefined,
		credentials: 'include',
	}).then((response) => {
		if (
			url !== 'PageOnloadGetLoginDetails' &&
			url !== 'Logout' &&
			url !== 'SessionKeepAlive' &&
			url !== 'getRealtimeAnalyticsForWebAware'
		) {
			if (Timer.hasStarted) {
				Timer.restart();
			} else if (url === 'Logout') {
				Timer.clearTimer();
			} else {
				Timer.start(10, 'min');
			}
		}
		if (infoObject && infoObject.needStatusCode) {
			return new Promise((resolve) => {
				response
					.json()
					.then((d) => resolve({ statusCode: response.status, ...d }));
			});
		}
		return response.json();
	});
};

export const getTimeDiff = (time: string): string => {
	const date = new Date(time);
	const today = new Date();
	// const diff =
	//   Math.floor((today.getTime() - date.getTime()) / 1000 / 60) + date.getTimezoneOffset();
	const diff = Math.floor((today.getTime() - date.getTime()) / 1000 / 60) + 1; //hybriduat //muthoot
	if (diff > 60) {
		const hourDiff = Math.floor(diff / 60);

		return hourDiff + (hourDiff > 1 ? ' hours' : ' hour');
	} else {
		return diff + (diff > 1 ? ' mins' : ' min');
	}
};

export const getTimeDiffforTransfer = (time: string): string => {
	const date = new Date(time);
	const today = new Date();
	const diff =
		Math.floor((today.getTime() - date.getTime()) / 1000 / 60) +
		date.getTimezoneOffset();
	// const diff = Math.floor((today.getTime() - date.getTime()) / 1000 / 60) + 1; //hybriduat //muthoot
	if (diff > 60) {
		const hourDiff = Math.floor(diff / 60);

		return hourDiff + (hourDiff > 1 ? ' hours' : ' hour');
	} else {
		return diff + (diff > 1 ? ' mins' : ' min');
	}
};

export const getLocalDateAndTime = (
	time: string
): { date: string; time: string } => {
	const date = new Date(time);
	const tzOffset = date.getTimezoneOffset();
	const tzMinutes = date.getMinutes() - (tzOffset % 60);
	const minutes = tzMinutes % 60;
	// @ts-ignore
	const tzHours = date.getHours() - +(tzOffset / 60);
	const hours = Math.floor(tzHours) + Math.floor(tzMinutes / 60);

	return {
		date: date.toLocaleString('default', {
			weekday: 'short',
			month: 'short',
			year: 'numeric',
			day: 'numeric',
		}),
		time:
			`${hours > 12 ? hours - 12 : hours}`.padStart(2, '0') +
			':' +
			`${minutes}`.padStart(2, '0') +
			` ${hours > 12 ? 'PM' : 'AM'}`,
	};
};

export const toTitleCase = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
export function asyncExecutor(fn: Function, ...args: any) {
	setTimeout(fn, 0, ...args);
}
export function parseJSON(message: any) {
	var r = /<i .*>.*<\\?\/i>/g; //nosonar
	try {
		return JSON.parse(
			//   message
			//     .replace(/<p>.*?<\/p>/, '')
			//     .replace(/<i .*>.*<\\?\/i>/g, '')
			//     .replace(/<br.?\/?>/g, '')
			// ); //nosonar
			message
				.replace(/<p>.*?<\/p>/, '')
				.replace(r, '')
				.replace(/<br.?\/?>/g, '')
		); //nosonar
	} catch (e) {
		try {
			return JSON.parse(
				message
					.replace(/<p>.*?<\/p>/, '')
					//.replace(/<span.*class='apiresponsesplitter'>.*<\\?\/i>/,"")
					.replace(/<span.*class='apiresponsesplitter'>.*/, '')
			);
		} catch (e) {
			console.log('SFJSONParser -> parser error');
			return 'Incorrect answer format';
		}
	}
}
export function decodeHTMLTags(text: any) {
	return text
		.replace(/ class=\\?"Workflow-link\\?"/g, '')
		.replace(/ class=\\?"Workflow-link\\?"/g, '')
		.replace(/ class=\\?"wf-summary-confirm\\?"/g, '')
		.replace(/&nbsp;/g, ' ')
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/<a/g, `<a target='_blank'`);
}

// export default function debounce(func:any, wait:any, immediate:any) {
//   var timeout:any;
//   return function() {
//     var context = this,
//       args = arguments;
//     var later = function() {
//       timeout = null;
//       if (!immediate) func.apply(context, args);
//     };
//     var callNow = immediate && !timeout;
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//     if (callNow) func.apply(context, args);
//   };
// }

let debounce2Timer: any;
export function debounce2(func: any, time: any) {
	clearTimeout(debounce2Timer);
	debounce2Timer = setTimeout(func, time);
}
